import React from 'react';
import { createUseStyles } from 'react-jss';

import MenuItem from '../../../MenuItem';

const useStyles = createUseStyles((theme) => ({
  label: {
    fontWeight: 500,
    textDecoration: 'underline',
    marginTop: theme.spacing(5),
  },
}));

const ProfessionnalEducation = ({ result, label, data }) => {
  const classes = useStyles();

  return (
    <>     
      <li className={classes.label}>{label}</li>
      <MenuItem
        label="Name :"
        text={result?.us_educ_list}
        customValue={data.educ_name} 
      />
      {data.educ_degrees && (
        <MenuItem
          label="Degrees :"
          customValue={data.educ_degrees?.join(', ')}
          text={result?.us_educ_list}
        />
      )}
      {(data.educ_start || data.educ_end) && (
        <MenuItem
          label="Date :"
          customValue={data?.educ_start + ' to ' + data?.educ_end}
          text={result?.us_educ_list}
        />
      )}
    </>
  );
}

export default ProfessionnalEducation;